export enum AuthState {
    SIGNED_IN = 'SIGNED_IN',
    UNAUTHORIZED = 'UNAUTHORIZED',
    FETCHING = 'FETCHING',
    UNKNOWN = 'UNKNOWN',
}
